// @ts-nocheck
import NProgress from 'nprogress';
import { motion } from 'framer-motion';
import { useEffect, useMemo } from 'react';
import { styled } from '@mui/material/styles';
import { Box, GlobalStyles } from '@mui/material';
import { BRAND, SHIELD_BODY, SHIELD_FACET, SHIELD_INNER, SHIELD_W } from './brandAssets';

const nprogressGlobalStyles = (theme) => ({
  '#nprogress': {
    pointerEvents: 'none',
    '& .bar': {
      top: 0,
      left: 0,
      height: 2,
      width: '100%',
      position: 'fixed',
      zIndex: theme.zIndex?.snackbar,
      backgroundColor: BRAND.amber,
      boxShadow: `0 0 2px ${BRAND.amber}`,
    },
    '& .peg': {
      right: 0,
      opacity: 1,
      width: 100,
      height: '100%',
      display: 'block',
      position: 'absolute',
      transform: 'rotate(3deg) translate(0px, -4px)',
      boxShadow: `0 0 10px ${BRAND.amber}, 0 0 5px ${BRAND.amber}`,
    },
  },
});

const RootStyle = styled('div')(({ theme }) => ({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.background?.default,
}));

function ProgressBar() {
  useMemo(() => {
    NProgress.start();
  }, []);

  useEffect(() => {
    NProgress.done();
  }, []);

  return <GlobalStyles styles={nprogressGlobalStyles} />;
}

const CYCLE = 3.2;

// Loop: shield outline draws itself → fills with the faceted amber →
// the W draws through to its checkmark kick → holds → everything
// recedes and the outline starts again.
export default function LoadingScreen({ ...other }) {
  return (
    <RootStyle {...other}>
      <ProgressBar />

      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 150,
          height: 150,
        }}
      >
        <Box
          component={motion.div}
          animate={{ scale: [1, 1.12, 1], opacity: [0.1, 0.24, 0.1] }}
          transition={{ duration: CYCLE, repeat: Infinity, ease: 'easeInOut' }}
          sx={{
            position: 'absolute',
            width: 134,
            height: 134,
            borderRadius: '36%',
            border: `2px solid ${BRAND.amber}`,
          }}
        />

        <motion.svg width={86} height={97} viewBox="0 0 64 72" style={{ display: 'block' }}>
          {/* 1 · outline draw */}
          <motion.path
            d={SHIELD_BODY}
            fill="none"
            stroke={BRAND.amber}
            strokeWidth="3"
            strokeLinejoin="round"
            animate={{ pathLength: [0, 1, 1, 1], opacity: [1, 1, 0, 0] }}
            transition={{ duration: CYCLE, repeat: Infinity, times: [0, 0.28, 0.4, 1], ease: 'easeInOut' }}
          />

          {/* 2 · faceted fill */}
          <motion.g
            animate={{ opacity: [0, 0, 1, 1, 0] }}
            transition={{ duration: CYCLE, repeat: Infinity, times: [0, 0.26, 0.4, 0.86, 1], ease: 'easeInOut' }}
          >
            <path d={SHIELD_BODY} fill={BRAND.amber} />
            <path d={SHIELD_FACET} fill={BRAND.amberDeep} />
            <path d={SHIELD_INNER} fill="none" stroke="#FFFFFF" strokeOpacity=".28" strokeWidth="1.3" />
          </motion.g>

          {/* 3 · W draws through to the check kick */}
          <motion.path
            d={SHIELD_W}
            fill="none"
            stroke="#FFFFFF"
            strokeWidth="6"
            strokeLinecap="round"
            strokeLinejoin="round"
            animate={{ pathLength: [0, 0, 1, 1, 0], opacity: [0, 0, 1, 1, 0] }}
            transition={{ duration: CYCLE, repeat: Infinity, times: [0, 0.42, 0.66, 0.88, 1], ease: 'easeInOut' }}
          />
        </motion.svg>
      </Box>
    </RootStyle>
  );
}
